import React from "react";
import "./style.css";

function Footer() {
  return (
    <footer>
      <a
        href="https://www.linkedin.com/in/taylorniles117/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fa fa-linkedin-square icon"></i>
      </a>
      <a
        href="https://github.com/tniles320"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fa fa-github icon"></i>
      </a>
      <a
        href="https://www.instagram.com/hermdaddy/"
        rel="noopener noreferrer"
        target="_blank"
      >
        <i className="fa fa-instagram icon"></i>
      </a>
    </footer>
  );
}

export default Footer;
